// IDENTITY COLOR — the designs (DocujointOverview/DocujointKb/DocujointOrg,
// imported 2026-08-06) mark every organization and knowledge base with a small
// colored dot, and the SAME entity wears the SAME hue everywhere: the scope
// pickers, the shelf cards, the workspace hero. Nothing stores a color — the
// hue is a pure function of the NAME, so every surface computes it and they
// can never disagree, exactly like the name-to-CSS rule appearance-tokens.ts
// follows.
//
// The palette is the designs' own: oklch(0.62 0.14 H) — constant lightness and
// chroma so every dot reads equally against both modes, hue from the name.

/** A stable 32-bit hash — FNV-1a, small and good enough for a hue. */
function hashOf(name: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < name.length; i++) {
    hash ^= name.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

/** The identity hue for a name, as the designs spell it. */
export function identityColor(name: string): string {
  return `oklch(0.62 0.14 ${hashOf(name) % 360})`;
}
